//import('./carousel.js')
import navmanager from "./_navmanager";
import bannercontroller from "./_bannercontrol";
import scrollController from "./_scrollcontrol";

import collapse from '@alpinejs/collapse';


//Main Banner
function bannercontrol() {
    const bannercontrolled = document.querySelectorAll('.banner-control');
    bannercontrolled.forEach(el => {
        const banner = new bannercontroller(el);
    });
}

//Carousels
function scrollcontrol() {
    const scrollcontrolled = document.querySelectorAll('.scroll-control');
    scrollcontrolled.forEach(el => {
        const sc = new scrollController(el);
    });
}

function backtotop(){
    // Select the element
    const backToTopButton = document.getElementById('back-to-top');

    if(backToTopButton != undefined){
        backToTopButton.addEventListener('click', function() {
            // Scroll to the top of the page smoothly
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    var backToTopButtonMobile = document.getElementById('back-to-top-mobile');
    if (backToTopButtonMobile != undefined) {
        backToTopButtonMobile.addEventListener('click', function () {
            // Scroll to the top of the page smoothly
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}

//Loading Var prevents double trigger if onload called from elsewhere.
var loading = true;
window.onload = function () {
    if (loading) {
        navmanager.init();
        bannercontrol();
        scrollcontrol();
        backtotop();
    }
};

document.addEventListener('DOMContentLoaded', function() {
    let app = document.getElementById('app');

    if(app) {
        new Vue({
            el: '#app', // Mount to the body tag
        });
    }

});
